(function() {
  'use strict';

  const CONFIG = {
    endpoint: 'https://xpsq-sdbm-bcmj.n7e.xano.io/api:FGUScUBu/track_page_health',
    pageName: window.location.pathname,
    idleTimeout: 30000,
    scrollDepthIntervals: [25, 50, 75, 90, 100],
    debounceDelay: 100
  };

  const PageHealthTracker = {
    dataSent: false,
    session: {
      sessionId: null,
      pageLoadTime: null,
      
      source: {
        referrer: null,
        direct: false,
        source: null,
        medium: null,
        campaign: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmTerm: null,
        utmContent: null
      },
      
      behavior: {
        duration: 0,
        clicks: [],
        scrollDepth: 0,
        maxScrollDepth: 0,
        scrolledToDepths: [],
        addedToCart: false,
        interactionCount: 0,
        isActive: false,
        lastActivityTime: null
      },
      
      exit: {
        exitUrl: null,
        exitType: null,
        exitTime: null,
        clickedCheckout: false
      }
    },

    init() {
      this.session.sessionId = this.generateSessionId();
      this.session.pageLoadTime = new Date();
      this.session.behavior.lastActivityTime = new Date();
      
      this.captureSource();
      this.setupEventListeners();
      this.startDurationTracking();
      this.trackInitialScrollPosition();
    },

    generateSessionId() {
      return 'phs_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    },

    captureSource() {
      this.session.source.referrer = document.referrer || null;
      this.session.source.direct = !document.referrer;
      
      if (document.referrer) {
        try {
          const referrerUrl = new URL(document.referrer);
          const currentUrl = new URL(window.location.href);
          
          if (referrerUrl.hostname === currentUrl.hostname) {
            this.session.source.source = 'internal';
            this.session.source.medium = 'navigation';
          } else {
            const hostname = referrerUrl.hostname.toLowerCase();
            if (hostname.includes('google')) {
              this.session.source.source = 'google';
              this.session.source.medium = hostname.includes('ads') ? 'cpc' : 'organic';
            } else if (hostname.includes('facebook') || hostname.includes('fb.com')) {
              this.session.source.source = 'facebook';
              this.session.source.medium = 'social';
            } else if (hostname.includes('instagram')) {
              this.session.source.source = 'instagram';
              this.session.source.medium = 'social';
            } else if (hostname.includes('twitter') || hostname.includes('t.co')) {
              this.session.source.source = 'twitter';
              this.session.source.medium = 'social';
            } else if (hostname.includes('linkedin')) {
              this.session.source.source = 'linkedin';
              this.session.source.medium = 'social';
            } else {
              this.session.source.source = referrerUrl.hostname;
              this.session.source.medium = 'referral';
            }
          }
        } catch (e) {
          console.error('Error parsing referrer:', e);
        }
      }
      
      const urlParams = new URLSearchParams(window.location.search);
      this.session.source.utmSource = urlParams.get('utm_source');
      this.session.source.utmMedium = urlParams.get('utm_medium');
      this.session.source.utmCampaign = urlParams.get('utm_campaign');
      this.session.source.utmTerm = urlParams.get('utm_term');
      this.session.source.utmContent = urlParams.get('utm_content');
      
      if (this.session.source.utmSource) {
        this.session.source.source = this.session.source.utmSource;
      }
      if (this.session.source.utmMedium) {
        this.session.source.medium = this.session.source.utmMedium;
      }
      if (this.session.source.utmCampaign) {
        this.session.source.campaign = this.session.source.utmCampaign;
      }
    },

    setupEventListeners() {
      document.addEventListener('click', this.handleClick.bind(this));
      
      window.addEventListener('scroll', this.debounce(this.handleScroll.bind(this), CONFIG.debounceDelay));
      
      this.trackAddToCart();
      
      this.trackPageExit();
      
      this.checkIdleStatus();
    },

    handleClick(event) {
      const target = event.target;
      const clickData = {
        timestamp: new Date().toISOString(),
        element: target.tagName,
        text: target.textContent?.substring(0, 50) || '',
        classes: target.className || '',
        href: null,
        isCheckout: false,
        isAddToCart: false
      };
      
      const link = target.closest('a');
      if (link) {
        clickData.href = link.href;
        
        if (link.href.includes('/checkout') || 
            link.textContent.toLowerCase().includes('checkout') ||
            link.className.toLowerCase().includes('checkout')) {
          clickData.isCheckout = true;
          this.session.exit.clickedCheckout = true;
        }
      }
      
      const button = target.closest('button, input[type="submit"]');
      if (button) {
        const buttonText = button.textContent?.toLowerCase() || '';
        const buttonClasses = button.className?.toLowerCase() || '';
        if (buttonText.includes('add to cart') || 
            buttonText.includes('add to bag') ||
            buttonClasses.includes('add-to-cart') ||
            button.getAttribute('data-add-to-cart')) {
          clickData.isAddToCart = true;
          this.session.behavior.addedToCart = true;
        }
      }
      
      this.session.behavior.clicks.push(clickData);
      this.session.behavior.interactionCount++;
      
      if (clickData.isCheckout || clickData.isAddToCart || link || button) {
        this.updateActivity();
      }
    },

    handleScroll() {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      const scrollPercentage = Math.round((scrollTop / (documentHeight - windowHeight)) * 100);
      
      this.session.behavior.scrollDepth = scrollPercentage;
      
      if (scrollPercentage > this.session.behavior.maxScrollDepth) {
        this.session.behavior.maxScrollDepth = scrollPercentage;
      }
      
      CONFIG.scrollDepthIntervals.forEach(depth => {
        if (scrollPercentage >= depth && !this.session.behavior.scrolledToDepths.includes(depth)) {
          this.session.behavior.scrolledToDepths.push(depth);
          if (depth >= 25) {
            this.updateActivity();
          }
        }
      });
    },

    trackInitialScrollPosition() {
      setTimeout(() => {
        this.handleScroll();
      }, 100);
    },

    trackAddToCart() {
      const originalFetch = window.fetch;
      window.fetch = function(...args) {
        const [url] = args;
        
        if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change'))) {
          return originalFetch.apply(this, args).then(response => {
            if (response.ok) {
              PageHealthTracker.session.behavior.addedToCart = true;
              PageHealthTracker.updateActivity();
            }
            return response;
          });
        }
        
        return originalFetch.apply(this, args);
      };
      
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (form.action && form.action.includes('/cart/add')) {
          this.session.behavior.addedToCart = true;
          this.updateActivity();
        }
      });
    },

    updateActivity() {
      const now = new Date();
      const timeOnPage = (now - this.session.pageLoadTime) / 1000;
      
      if (timeOnPage >= 5) {
        this.session.behavior.lastActivityTime = now;
        this.session.behavior.isActive = true;
      }
    },

    checkIdleStatus() {
      setInterval(() => {
        const now = new Date();
        const timeSinceLastActivity = now - this.session.behavior.lastActivityTime;
        
        if (timeSinceLastActivity > CONFIG.idleTimeout && this.session.behavior.isActive) {
          this.session.behavior.isActive = false;
        }
      }, 5000);
    },

    startDurationTracking() {
      this.durationInterval = setInterval(() => {
        const now = new Date();
        this.session.behavior.duration = Math.floor((now - this.session.pageLoadTime) / 1000);
      }, 1000);
    },

    trackPageExit() {
      window.addEventListener('beforeunload', (e) => {
        this.handlePageExit('closed');
      });
      
      document.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (link && link.href) {
          const linkUrl = new URL(link.href, window.location.origin);
          const currentUrl = new URL(window.location.href);
          
          if (linkUrl.href !== currentUrl.href && !link.target?.includes('blank')) {
            this.session.exit.exitUrl = linkUrl.href;
            this.session.exit.exitType = 'navigation';
            this.session.exit.exitTime = new Date().toISOString();
            
            this.sendData('navigation');
          }
        }
      });
    },

    handlePageExit(type) {
      clearInterval(this.durationInterval);
      
      const now = new Date();
      this.session.behavior.duration = Math.floor((now - this.session.pageLoadTime) / 1000);
      
      if (!this.session.behavior.isActive) {
        this.session.exit.exitType = 'idle';
      } else {
        this.session.exit.exitType = type;
      }
      this.session.exit.exitTime = now.toISOString();
      
      this.sendData(this.session.exit.exitType);
    },

    sendData(trigger) {
      if (this.dataSent) {
        return;
      }
      
      if (!CONFIG.endpoint || CONFIG.endpoint === 'YOUR_ANALYTICS_ENDPOINT') {
        return;
      }
      
      this.dataSent = true;
      
      const flatData = {
        session_id: this.session.sessionId,
        page_name: CONFIG.pageName,
        page_url: window.location.href,
        timestamp: new Date().toISOString(),
        trigger: trigger,
        
        referrer_url: this.session.source.referrer || null,
        is_direct: this.session.source.direct,
        traffic_source: this.session.source.source || null,
        traffic_medium: this.session.source.medium || null,
        campaign: this.session.source.campaign || null,
        utm_source: this.session.source.utmSource || null,
        utm_medium: this.session.source.utmMedium || null,
        utm_campaign: this.session.source.utmCampaign || null,
        utm_term: this.session.source.utmTerm || null,
        utm_content: this.session.source.utmContent || null,
        
        duration_seconds: this.session.behavior.duration,
        max_scroll_depth: this.session.behavior.maxScrollDepth,
        scroll_milestones: JSON.stringify(this.session.behavior.scrolledToDepths),
        click_count: this.session.behavior.clicks.length,
        interaction_count: this.session.behavior.interactionCount,
        added_to_cart: this.session.behavior.addedToCart,
        was_active: this.session.behavior.isActive,
        
        exit_url: this.session.exit.exitUrl || null,
        exit_type: this.session.exit.exitType || null,
        exit_time: this.session.exit.exitTime || null,
        clicked_checkout: this.session.exit.clickedCheckout
      };
      
      fetch(CONFIG.endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(flatData),
        keepalive: true
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          return response.text().then(text => {
            console.error('Error response:', text);
          });
        }
      })
      .then(data => {
        if (data) {
          console.log('Response from server:', data);
        }
      })
      .catch(error => {
        console.error('Error sending analytics:', error);
      });
    },

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => PageHealthTracker.init());
  } else {
    PageHealthTracker.init();
  }

  window.PageHealthTracker = PageHealthTracker;

})();
